import React from 'react';
import { Helmet } from 'react-helmet-async';

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Dental Stores</title>
        <meta name="description" content="Learn about Dental Stores' mission, values, and background. We are committed to providing quality dental products and services." />
      </Helmet>
      <div style={{ padding: '48px 24px 80px', maxWidth: '960px', margin: '0 auto', color: '#1f2933' }}>
        <header style={{ marginBottom: '48px' }}>
          <p style={{ margin: 0, color: '#1565C0', fontWeight: '600', letterSpacing: '0.4em', textTransform: 'uppercase', fontSize: '12px' }}>
            Who we are
          </p>
          <h1 style={{ fontSize: '40px', fontWeight: '700', margin: '12px 0 0', lineHeight: 1.2, color: '#102a43' }}>
            About Dental Stores
          </h1>
          <p style={{ marginTop: '18px', fontSize: '17px', lineHeight: 1.7, maxWidth: '720px', color: '#52606d' }}>
            We partner with dental professionals to deliver trusted products, faster support, and a smoother buying experience for every practice.
          </p>
        </header>

        <section style={{ display: 'grid', gap: '36px' }}>
          <article style={{ display: 'grid', gap: '12px' }}>
            <h2 style={{ fontSize: '26px', fontWeight: '600', margin: 0, color: '#102a43' }}>Our Mission</h2>
            <p style={{ margin: 0, fontSize: '17px', lineHeight: 1.7, color: '#52606d' }}>
              At Dental Stores, our mission is to provide high-quality dental products and exceptional customer support to professionals and patients worldwide. We strive to make dental care accessible, affordable, and effective.
            </p>
          </article>

          <article>
            <h2 style={{ fontSize: '26px', fontWeight: '600', marginBottom: '16px', color: '#102a43' }}>Our Values</h2>
            <ul style={{ margin: 0, paddingLeft: '22px', display: 'grid', gap: '10px', fontSize: '16px', color: '#1f2933' }}>
              <li><strong>Quality:</strong> We ensure every product meets the highest standards of safety and efficacy.</li>
              <li><strong>Innovation:</strong> We continuously explore new ways to improve dental care through technology and research.</li>
              <li><strong>Integrity:</strong> We operate with honesty, transparency, and ethical practices.</li>
              <li><strong>Customer focus:</strong> Our customers' satisfaction and well-being guide every decision.</li>
              <li><strong>Community:</strong> We actively support the dental community and oral health initiatives.</li>
            </ul>
          </article>

          <article style={{ display: 'grid', gap: '12px' }}>
            <h2 style={{ fontSize: '26px', fontWeight: '600', margin: 0, color: '#102a43' }}>Our Background</h2>
            <p style={{ margin: 0, fontSize: '17px', lineHeight: 1.7, color: '#52606d' }}>
              Founded in 2020, Dental Stores has grown from a small local supplier to a trusted national provider of dental products. We began with a simple idea: make quality dental supplies easily accessible to practitioners and patients alike.
            </p>
            <p style={{ margin: 0, fontSize: '17px', lineHeight: 1.7, color: '#52606d' }}>
              We now serve thousands of clinics, hospitals, and individual practitioners, supplying everything from daily essentials to advanced equipment. Our commitment to excellence and reliable service has positioned us as a leader in the dental industry.
            </p>
          </article>

          <article style={{ display: 'grid', gap: '12px' }}>
            <h2 style={{ fontSize: '26px', fontWeight: '600', margin: 0, color: '#102a43' }}>Why Choose Us?</h2>
            <p style={{ margin: 0, fontSize: '17px', lineHeight: 1.7, color: '#52606d' }}>
              With years of experience and a dedication to quality, Dental Stores is the go-to source for dental needs. Expect competitive pricing, quick shipping, and a support team that understands the demands of your practice.
            </p>
          </article>
        </section>
      </div>
    </>
  );
};

export default AboutUs;
